import { useCallback, useState } from 'react';
import { createEngagementClient } from '../../../../src/services/client';
import { ADD_FAVORITE_CONTENT } from '../engagementGql/favoriteContent';
import { addErrorInDatadogRum } from '../utils/utilities';

const WORKOUT_CONTENT_TYPE = 'workout';

type AddFavoriteWorkoutParams = {
  programName: string;
  workoutName: string;
};

const useAddFavoriteWorkout = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const addFavoriteWorkout = useCallback(
    async ({ programName, workoutName }: AddFavoriteWorkoutParams) => {
      setIsProcessing(true);
      try {
        await createEngagementClient.mutate({
          mutation: ADD_FAVORITE_CONTENT,
          variables: {
            contentType: WORKOUT_CONTENT_TYPE,
            contentId: `${programName}|${workoutName}`,
          },
        });
      } catch (error) {
        addErrorInDatadogRum(error);
      } finally {
        setIsProcessing(false);
      }
    },
    []
  );

  return { addFavoriteWorkout, isProcessing };
};

export default useAddFavoriteWorkout;
